export default "__VITE_ASSET__CMFk6LK$__"